import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import Parent from 'common/services/Parent'

const Checkmark = require('embed/components/ApplicationField/check-green.svg')

const styles = require('./styles')

const Confirmation: React.SFC = ({ children }) => {
  React.useEffect(Parent.scrollToFrame, [])

  return (
    <ThemeConsumer>
      {({ borderRadiusLarge, backdropStyles, boxStyles, colorBorder }) => (
        <div
          className={classnames(
            styles.container,
            css`
              background-color: ${backdropStyles.backgroundColor};
              border-color: ${colorBorder};
              border-radius: ${borderRadiusLarge};
            `,
          )}
          style={boxStyles}
        >
          <Checkmark />
          <h2>Here’s to living worry-free!</h2>
          <p>{children}</p>
        </div>
      )}
    </ThemeConsumer>
  )
}

export const PersonalInfoConfirmation: React.SFC = () => (
  <Confirmation>
    Thank you for choosing us. One of our agents will contact you shortly to go over your submitted information and
    complete your application.
  </Confirmation>
)

export const RequestACallConfirmation: React.SFC = () => (
  <Confirmation>Thank you for choosing us. One of our agents will contact you soon.</Confirmation>
)
